export const breakpoints = {
    mobile: 0,
    mobileLarge: 576,
    tablet: 768,
    desktop: 992,
    desktopLarge: 1200
  }
  